module.exports = __webpack_public_path__ + "static/media/customer_statements.e11c34a5.svg";